import React from 'react';

const facebookPage = 'https://www.facebook.com/BeyondTheBlueJABH';
const facebookEmbed = `https://www.facebook.com/plugins/page.php?href=${encodeURIComponent(facebookPage)}&tabs=timeline&width=500&height=620&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true`;

const FilmSocialFeed = () => (
  <section className="world-space-week-social" aria-labelledby="film-social-feed-title">
    <div className="world-space-week-social-inner">
      <header className="world-space-week-social-header">
        <p className="section-eyebrow">STAY CONNECTED</p>
        <h2 id="film-social-feed-title">Social Feed</h2>
        <div className="world-space-week-title-line" aria-hidden="true" />
      </header>

      <div className="world-space-week-facebook-wrap">
        <iframe
          title="Beyond the Blue Facebook feed"
          src={facebookEmbed}
          width="500"
          height="620"
          scrolling="no"
          frameBorder="0"
          allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
          loading="lazy"
        />
      </div>

      <a
        className="world-space-week-facebook-link"
        href={facebookPage}
        target="_blank"
        rel="noopener noreferrer"
      >
        View Beyond the Blue on Facebook <span aria-hidden="true">→</span>
      </a>
    </div>
  </section>
);

export default FilmSocialFeed;
